<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 270px">
      <div id="main_area">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>發送時機：</td>
                  <td>
                    <input
                      type="text"
                      maxlength="10"
                      v-model="form.emailday"
                    />日
                    <label style="color: red"
                      >(截止日前7日請填7，逾期1日請填-1，期限當天請填0)</label
                    >
                  </td>
                </tr>
                <tr>
                  <td>發送方式：</td>
                  <td>
                    <input
                      type="radio"
                      name="RadioGroup1"
                      value="1"
                      v-model="form.grouptype"
                      checked="checked"
                    />整批
                    <input
                      type="radio"
                      name="RadioGroup1"
                      value="2"
                      v-model="form.grouptype"
                    />分批
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <!-- <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="doQuery()"
                    /> -->
                    <input
                      type="submit"
                      class="btn"
                      value="新增"
                      @click="btnAdd()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="doClear()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 查詢結果開始-->
    <div class="information">
      <table width="100%">
        <tbody>
          <tr>
            <td v-if="grid.paginaiton" align="right">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
                maxlength="4"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
                maxlength="4"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
          </tr>
        </tbody>
      </table>
      <div class="active">
        <div class="table_scroll2">
          <table width="1060" class="itable">
            <thead>
              <tr>
                <th style="min-width: 80px">操作</th>
                <th style="min-width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('emailDay', Sort);
                      }
                    "
                    >通知時機</u
                  >
                </th>
                <th style="width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('groupType', Sort);
                      }
                    "
                    >發送方式</u
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in grid.gridDatas" :key="index">
                <td width="1%" align="center">
                  <input
                    type="button"
                    class="btn"
                    @click="btnDelete(data)"
                    value="刪"
                  />
                </td>
                <td>{{ data.emailDay }}</td>
                <td>{{ data.groupType }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 查詢結果結束-->
    <PdisFooter />

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  S404_SearchGrid,
  S404_ReSearchGrid,
  S404_Delete,
  S404_Detail,
  S404_DetailAddSave,
  S404_DetailEditSave,
} from "@/service/api.js";
export default {
  name: "S404",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S404",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      Order: "",
      Sort: "",
      form: {
        emailday: "",
        grouptype: "1",
        pagesize: 10,
        currentpage: 1,
        allSelected: false,
      },
      modifyType: "",
      grid: {},
      PreData: {},
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
  },
  methods: {
    //第一頁查詢
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S404_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "emailDay";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      S404_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁重填
    doClear: function () {
      this.form = {
        emailday: "",
        grouptype: "1",
        pagesize: 10,
        currentpage: 1,
      };
    },
    //全選
    btnAllCheck: function () {
      const self = this;
      self.form.Selected = [];
      if (!this.allSelected) {
        self.grid.gridDatas.forEach((g) =>
          self.form.Selected.push({ pkno: g.pkno })
        );
      }
    },
    //取消
    btnCancelCheck: function () {
      const self = this;
      self.form.Selected = [];
    },
    //第一頁新增
    btnAdd: function () {
      const self = this;
      self.PreData = {};
      self.modifyType = "I";
      self.S404_DetailAddSave();
    },
    //gird
    //第一頁編
    btnEdit: function (data) {
      const self = this;
      self.PreData = data;
      self.getDetailData();
      self.modifyType = "U";
      self.title = "S404 -編輯";
      self.show = true;
    },
    //第一頁刪
    btnDelete: function (data) {
      const self = this;
      let postData = {
        pkno: data.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S404_Delete(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第一頁整批刪除按紐
    btnDeleteAll: function () {
      const self = this;
      if (self.form.Selected.length) {
        self.grid.gridDatas.forEach((g) => self.btnDelete({ pkno: g.pkno }));
        //self.modal.show = true;
        //self.btnModalClear();
        //self.modalGetOnJob();
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先勾選移轉名單!"];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      }
    },
    checkInputData: function () {
      const self = this;
      let msg = [];
      if (!self.form.emailday) {
        msg.push("請填寫發送日");
      } else if (isNaN(parseInt(self.form.emailday))) {
        msg.push("發送日需為整數");
      }
      if (!self.form.grouptype) {
        msg.push("請填寫發送方式");
      }
      return msg;
    },
    //第二頁明細新增 API
    S404_DetailAddSave: function () {
      const self = this;
      let errMsg = self.checkInputData();
      if (errMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = errMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      } else {
        let postData = {
          pkno: 0,
          emailday: self.form.emailday,
          grouptype: self.form.grouptype,
          userid: "", //self.loginInfo.id
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁明細新增",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        console.log(JSON.stringify(postData));
        S404_DetailAddSave(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.show = false;
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    //第二頁明細修改 API
    S404_DetailEditSave: function () {
      const self = this;
      let errMsg = self.checkInputData();
      if (errMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = errMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      } else {
        let postData = {
          pkno: self.PreData.pkno,
          emailday: self.form.emailday,
          grouptype: self.form.grouptype,
          userid: "", //self.loginInfo.id
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁明細修改",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        console.log(JSON.stringify(postData));
        S404_DetailEditSave(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["修改成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.show = false;
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["修改失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    //第二頁按紐明細存檔
    btnDetailSave: function () {
      const self = this;
      if (self.modifyType == "I") {
        self.S404_DetailAddSave();
      } else if (self.modifyType == "U") {
        self.S404_DetailEditSave();
      }
    },
    //第二頁明細重填
    btnDetailClear: function () {
      const self = this;
      self.form = {
        emailday: "",
        grouptype: "",
        pagesize: 10,
        currentpage: 1,
      };
    },
    //匯入頁
    ImportModalOnFileChange: function (event) {
      const self = this;
      self.ImportModal.form.updloaD_FILE = event.target.files[0];
    },
    //匯入頁 按紐匯入
    ImportModalBtnImport: function () {
      const self = this;
      if (self.ImportModal.form.updloaD_FILE) {
        let formData = new FormData();
        formData.append("UPDLOAD_FILE", self.ImportModal.form.updloaD_FILE);
        S404_Import(formData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["匯入成功"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["匯入失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先選取匯入檔案"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.doQuery();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
